import { useFormik } from "formik";
import { coaFormValidationSchema, coaFormValues } from "./Common";
import { Accordion, AccordionDetails, AccordionSummary, Divider, FormControl, FormLabel, Grid, Typography } from "@mui/material";
import FormikControl from "../../common/FormikControl";
import { useEffect, useState, useMemo } from "react";
import { CheckGreen, DownIcon, InfoIcon } from "../../../../assets/common-svg/CommonSvg";
import SkeletonLoader from "../../../../utilites/SkeltonLoader";
import { dateFormater } from "../../../utils/common/utils";
import { getSubLabel } from "../../../../utils/utils";
import { createCoaForm, getCoaFormDetailsById, selectIsLoadingDetails } from "../../../slices/qualityControl";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { fetchQueryList } from "../../../slices/queryInBound";
import { getNestedValue } from "../../../../pages/appointment-details/common-pre-screen/common";
import COAComment from "./Common/coaComment";
import CoaFormButtons from "./Common/coaFormButtons";
import { hasAuthority } from "../../../../utils/authorities";
import { notify } from "../../../utils/methods/notification";
import CoaQueryHistory from "../../../pages/CommonCoaQuery/CoaQueryHistory";
import { selectCurrentCycle,setCoaFormData } from "../../../slices/common";
import { LoadingButton } from "@mui/lab";
import COAPrint from "../../../pages/Manufacturer/COAPrint";

const COAForm = ({ patientData, updateTimeLine, fetchPatientInfo, initialSteps }) => {
    const dispatch = useDispatch()
    const currentCycle = useSelector(selectCurrentCycle)
    const [disabledAll, setDisabledAll] = useState(false)
    const [checkCOAForm, setCheckCOAForm] = useState({})
    const [coaFormExpanded, setCoaFormExpanded] = useState(true)
    const [queriesFields, setQueryFields] = useState([]);
    const [selectedField, setSelectedField] = useState(null);
    const [queryData, setQueryData] = useState(null);
    const [checkForm, setCheckForm] = useState({})
    const isLoadingDetails = useSelector(selectIsLoadingDetails)
    const coaFormApproved = initialSteps?.find(op => op.slug == "qa-review")?.status == 2
    const [coaPrintModal,setCoaPrintModal]=useState(false)
    const LoginData = useSelector((state) => state.loginData);
    const bmr_permissions = LoginData?.bmr_permissions || [];
    const isShowPrintButtonCOA =['quality-associate']?.includes(LoginData?.role_slug) && currentCycle?.coa_forms_id
    const [anchorEl, setAnchorEl] = useState(null);
    const [isDraft, setIsDraft] = useState(false);
    
    const open = Boolean(anchorEl) || false;
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const canShowQcRemark = useMemo(() => {
        const steps = initialSteps?.find(op => op.slug === "qc-testing")?.status
        return (
       (steps == 4 || steps == 5 || steps == 3 || steps == 2) && (hasAuthority(["quality-analyst-approve"], bmr_permissions) || (hasAuthority(["quality-control-lead-approval"], bmr_permissions) || hasAuthority(["quality-control-lead-reject"], bmr_permissions)))
        );
    }, [initialSteps, bmr_permissions]);

     const canShowQaRemarks = useMemo(() => {
        const steps = initialSteps?.find(op => op.slug === "qc-testing")?.status
        const qaSteps = initialSteps?.find(op => op.slug === "qa-review")?.status
        return (
       hasAuthority(["quality-approval-approve-form"], bmr_permissions) && (steps == 2 && (qaSteps == 0 || qaSteps == 2 || qaSteps == 3))
        );
    }, [initialSteps, bmr_permissions]);

        const enableFields = useMemo(() => {
            const manufacturingStep = initialSteps?.find(op => op.slug === "qc-testing");
            return (manufacturingStep?.status == 4) &&
                hasAuthority(["quality-control-lead-approval"], bmr_permissions);
        }, [initialSteps, bmr_permissions]);

        const enableQAFields = useMemo(() => {
        const manufacturingStep = initialSteps?.find(op => op.slug === "qc-testing");
        const qaSteps = initialSteps?.find(op => op.slug === "qa-review")?.status

        return (manufacturingStep?.status == 3 || manufacturingStep?.status == 4  || qaSteps === 3 || qaSteps === 2) &&
            hasAuthority(["quality-approval-approve-form"], bmr_permissions);
    }, [initialSteps, bmr_permissions]);

    const preFilledData = {
        product_name: patientData?.product_name || "",
        batch_no: currentCycle?.batch_no || "",
        immunoact_patient_id: patientData?.patientId || "",
        product_id: patientData?.product_id || patientData?.product_id || "",
        mfg_date: currentCycle?.mfg_at ? dateFormater(currentCycle?.mfg_at) : "",
        product_manufacturing_id: currentCycle?.product_manufacturing_id || "",
        expired_at: currentCycle?.mfg_at
            ? dateFormater(new Date(new Date(currentCycle?.mfg_at).setMonth(new Date(currentCycle?.mfg_at).getMonth() + 3)))
            : "",
    }
    const [initialValues, setInitialValues] = useState(coaFormValues)
    // Function to fetch fetchCoaForms
    const fetchCoaForms = async (coaFormId) => {
        if (!coaFormId) {
            if(hasAuthority(["quality-control-listing"], bmr_permissions))
                setDisabledAll(false)
            else
                setDisabledAll(true)
            setInitialValues({ ...preFilledData, ...coaFormValues })
            return;
        }
        try {
            const response = await dispatch(
                getCoaFormDetailsById(coaFormId)
            ).unwrap();

            if (response?.data) {
                // setCoaFormData(response.data);
                const dataValues = response?.data
                if (dataValues?.status != 4 && currentCycle?.coa_forms_id) {
                    setDisabledAll(true)
                }else{
                    setDisabledAll(false)
                }
                setQueryFields(dataValues.queries);
                setInitialValues({ ...dataValues, ...preFilledData })
                setCheckCOAForm({ ...dataValues, ...preFilledData })
                dispatch(setCoaFormData({ ...dataValues, ...preFilledData }))
            }
        } catch (error) {
            console.error("Error fetching COA form details:", error);
        }
    };
    useEffect(() => {
        fetchCoaForms(currentCycle?.coa_forms_id)
    }, [currentCycle?.coa_forms_id, patientData]);
    // // Function to handle COA form submission
    const handleSubmit = async (values) => {
        const data = {
            ...values,
            qr_code_generated_id: patientData?.id,
            product_id: patientData?.product_id || "",
            patient_id: patientData?.patient_information?.id,
            feasibility_assesment_id: currentCycle?.feasibility_assessments_id,
            product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,
            expired_at: moment(values?.expired_at, "DD/MM/YYYY", true).toDate(),
            mfg_date: moment(values?.mfg_date, "DD/MM/YYYY", true).toDate(),
            is_draft : isDraft ? 1 : 0,
            status: isDraft ? 'draft' : 'submit',
            rcl_qpcr: values?.rcl_qpcr?.toString() ?? null, 
            sterility_culture_method_bactec: values?.sterility_culture_method_bactec?.toString() ?? null,
            multiplex_viral_test_pcr: values?.multiplex_viral_test_pcr?.toString() ?? null, 
            mycoplasma_pcr: values?.mycoplasma_pcr?.toString()  ?? null, 
            appearance: values?.appearance?.toString() ?? null, 
            car_surface_expression_flow_cytometry: values?.car_surface_expression_flow_cytometry ? values?.car_surface_expression_flow_cytometry : null, 
            cell_viability_dye_exclusion_method: values?.cell_viability_dye_exclusion_method ? values?.cell_viability_dye_exclusion_method : null, 
            ...currentCycle?.coa_forms_id ? {coa_id: currentCycle?.coa_forms_id}:{}
        }
        try {
            await dispatch(createCoaForm(data)).unwrap();
            if(!isDraft){
            fetchCoaForms(currentCycle?.coa_forms_id)
            await fetchPatientInfo()
            }
         await updateTimeLine()
           // setCoaFormExpanded(false)
        } catch (error) {
            console.error("Error creating COA form:", error);
            throw error;
        }
    };

    // // Function to handle getPrimaryDiagnosis
    const getPrimaryDiagnosis = async () => {
        const coaFormId = currentCycle?.coa_forms_id;
        const response = await dispatch(
            getCoaFormDetailsById(coaFormId)
        ).unwrap();
        if (response?.status == 200) {
            const dataValues = response?.data
            let data = { ...dataValues, ...preFilledData }
            setInitialValues(data)
            setCheckForm(data);
            setQueryFields(data.queries);
        }
    };

    // Menu handlers
    const handleQuestionClick = async (event, formProps) => {
        const { name, type, label, options } = formProps;
        const query = queriesFields?.find((op) => op.fields == name);

        setAnchorEl(event.currentTarget);
        const res = await dispatch(fetchQueryList(query?.field_id));
        if (res?.payload?.status == 200) {
            setQueryData(res?.payload?.data);
        } else {
            setQueryData([]);
        }

        const value =
            type == "select" || type == "radio"
                ? options?.find((op) => op.value == formik.values[name])?.label
                : getNestedValue(formik.values, name);

        setSelectedField({
            ...query,
            is_file: type == "file" ? true : false,
            field_label: label,
            field_name: name,
            prescreening_id: currentCycle?.coa_forms_id,
            patient_id: patientData?.patient_information?.id,
            field_value: value,
            isResolve: formProps?.isResolve
        });
    };

    const handleManualFormikValidaction = async () => {
        const errors = await formik.validateForm();

        if (Object.keys(errors).length > 0) {
            formik.setErrors(errors);

            const touchedFields = Object.keys(errors).reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            formik.setTouched(touchedFields);
            const errorList = Object.keys(errors)
                .map((key, index) => `${index + 1}. ${key}`)
                .join("\n");

            notify.error(`Following mandatory field(s) required:\n${errorList}`);
            return 0;
        } else {
            return 1;
        }
    };
    const formik = useFormik({
        initialValues: {
            ...preFilledData,
            ...initialValues,
        },
        validateOnBlur: false,
        validationSchema: coaFormValidationSchema(canShowQcRemark,canShowQaRemarks,isDraft),
        enableReinitialize: true,
        onSubmit: handleSubmit,
    });



    const formOptions = [
        { section: "Certificate of Analysis for NexCAR19TM" },
        {
            label: "Product Name",
            type: "text",
            noQuery: true,
            disabled: true,
            required: true,
            name: "product_name",
            placeholder: "Enter product name",
            col: 3,
        },
        {
            label: "Batch Number",
            type: "text",
            name: "batch_no",
            disabled: true,
            noQuery: true,
            required: true,
            col: 3,
        },
        {
            label: "Patient ID",
            type: "text",
            name: "immunoact_patient_id",
            disabled: true,
            noQuery: true,
            required: true,
            col: 3,
        },
        {
            label: "MFG Date",
            type: "date",
            name: "mfg_date",
            disabled: true,
            noQuery: true,
            required: true,
            col: 2,
        },
        {
            label: "Expiry Date",
            type: "date",
            name: "expired_at",
            disabled: true,
            noQuery: true,
            required: true,
            col: 2,
        }, {
            label: "Storage Conditions",
            type: "text",
            placeholder:"Enter Storage Conditions",
            name: "storage_condition",
            disabled: true,
            noQuery: true,
            required: true,
            col: 2,
        }, {
            label: "Specification No.",
            type: "text",
            placeholder:"Enter Specification No.",
            name: "specification_no",
            disabled: true,
            noQuery: true,
            required: true,
            col: 2,
        }, {
            label: "RCL",
            type: "text",
            name: "rcl_qpcr",
            disabled: disabledAll,
            placeholder:"Enter RCL",
            noQuery: coaFormApproved,
            isResolve: ['quality-check'],
            required: true,
            col: 3,
        },
        {
            label: "Sterility",
            type: "text",
            name: "sterility_culture_method_bactec",
            disabled: disabledAll,
            placeholder:"Enter Sterility",
            noQuery: coaFormApproved,
            isResolve: ['quality-check'],
            required: true,
            col: 3,
        }, {
            label: "Multiplex Viral test",
            type: "text",
            name: "multiplex_viral_test_pcr",
            placeholder:"Enter Multiplex Viral test",
            disabled: disabledAll,
            noQuery: coaFormApproved,
            isResolve: ['quality-check'],
            required: true,
            col: 3,
        },
        {
            label: "Mycoplasma",
            type: "text",
            name: "mycoplasma_pcr",
            placeholder:"Enter Mycoplasma",
            disabled: disabledAll,
            noQuery: coaFormApproved,
            isResolve: ['quality-check'],
            required: true,
            col: 2,
        },
        {
            label: "Appearance(Milky, No Aggregates)",
            type: "text",
            name: "appearance",
            placeholder:"Enter Appearance",
            disabled: disabledAll,
            noQuery: coaFormApproved,
            isResolve: ['quality-check'],
            required: true,
            col: 2,
        }, {
            label: "CAR surface expression",
            type: "text",
            name: "car_surface_expression_flow_cytometry",
            placeholder: "Enter CAR surface expression",
             subLable: "%",
            disabled: disabledAll,
            noQuery: coaFormApproved,
            isResolve: ['quality-check'],
            required: true,
            col: 2,
        },
        {
            label: "Cell viability",
            type: "text",
            name: "cell_viability_dye_exclusion_method",
            disabled: disabledAll,
            subLable: "%",
            placeholder: "Enter Cell viability",
            noQuery: coaFormApproved,
            isResolve: ['quality-check'],
            required: true,
            col: 2,
        }, {
            label: "CD19 + viable cell detection",
            type: "text",
            subLable: "%",
            name: "cd19_viable_cell_detection_flow_cytometry",
            placeholder: "Enter CD19 + viable cell detection",
            disabled: disabledAll,
            noQuery: coaFormApproved,
            isResolve: ['quality-check'],
            required: true,
            col: 2,
        }, {
            label: "Detection of magnetic beads",
            type: "text",
            subLable: "power",
            name: "detection_of_magnetic_beads_microscope",
            placeholder: "Enter Detection of magnetic beads",
            disabled: disabledAll,
            noQuery: coaFormApproved,
            isResolve: ['quality-check'],
            required: true,
            col: 2,
        }, {
            label: "Endotoxin level",
            type: "text",
            // subLable:"EU/mL", //@info commented to show the subLab
            name: "endotoxin_level",
            placeholder: "Enter Endotoxin level ",
            disabled: disabledAll,
            noQuery: coaFormApproved,
            isResolve: ['quality-check'],
            required: true,
            col: 2,
            getSubLabel: (formik) => getSubLabel(formik, 'endotoxin_level', 'EU/mL')
        }, {
            label: "Vector copy number-VCN",
            type: "text",
            // subLable:"copies per cell",
            name: "vector_copy_number_vcn_qpcr",
            placeholder: "Enter Vector copy number-VCN",
            disabled: disabledAll,
            noQuery: coaFormApproved,
            isResolve: ['quality-check'],
            required: true,
            col: 2,
           getSubLabel: (formik) => getSubLabel(formik, 'vector_copy_number_vcn_qpcr', 'copies per cell')
        }, {
            label: "Remarks",
            type: "textarea",
            name: "remarks",
            placeholder: "Enter Remarks ",
            disabled: disabledAll ,
            noQuery: true,
            required: true,
            col: 1,
        },
       ...(canShowQcRemark
    ? [
        {
          label: "Lead Remarks",
          type: "textarea",
          name: "lead_remarks",
          placeholder: "Enter Lead Remarks",
          disabled: !enableFields,
          noQuery: true,
          required: true,
          col: 1,
        },
      ]
    : []),
    ...(canShowQaRemarks
    ? [
        {
          label: "Remarks(QA)",
          type: "textarea",
          name: "qa_remarks",
          placeholder: "Enter Remarks",
          disabled: enableQAFields,
          noQuery: true,
          required: true,
          col: 1,
        },
      ]
    : []),
    ];

const handleCoaPrint = () =>{
    setCoaPrintModal(true)
  }

// Helper function to render dynamic subLabel
const renderDynamicSubLabel = (props, formik) => {
    const dynamicSubLabel = props.getSubLabel?.(formik);
    if (!dynamicSubLabel) return null;
    return (
        <Typography
            variant="span"
            className={`z-[1] font-semibold absolute right-5 ${
                formik.errors[props.name] && formik.touched[props.name] ? 'bottom-9' : 'bottom-4'
            } text-[0.7rem]`}
        >
            <span className="">{dynamicSubLabel}</span>
        </Typography>
    );
};

    return <div>
        <Accordion
            className={` w-100  !rounded-lg ${coaFormExpanded ? " pt-3" : " "}`}
            sx={{
                borderLeft: `4px solid ${!disabledAll ||
                  formik.values?.status == 4 || queriesFields?.filter((op) => op.resolve == 0)?.length > 0 
                    ? "#FB9D2C"
                    : "#00B278"
                    }`,
            }}
            expanded={coaFormExpanded} // <-- make it controlled
            onChange={() => setCoaFormExpanded((prev) => !prev)} // <-- toggle manually
        >
            <AccordionSummary
                expandIcon={
                    <div className="d-flex gap-3 align-items-center">
                        <DownIcon />
                    </div>
                }
                aria-controls="panel1-content"
                id="panel1-header"
            >
                {isLoadingDetails ? (
                    <div>
                        <SkeletonLoader
                            rowCount={1}
                            height={30}
                            width={200}
                            isTable={false}
                        />
                        <div className="flex gap-2">
                            <SkeletonLoader
                                rowCount={2}
                                height={30}
                                width={140}
                                isTable={false}
                            />
                        </div>
                    </div>
                ) : (
                        <div className="flex w-full items-center justify-between mr-2">
                        <div className="flex flex-col gap-2">
                        <span className="font-bold text-[0.9rem]"> Certificate Of Analysis</span>
                        <p className="flex gap-2">
                            {!disabledAll || formik.values?.status == 4 || 
                                queriesFields?.filter((op) => op.resolve == 0)?.length > 0 ? (
                                <span className="flex gap-3" style={{ color: "#FB9D2C" }}>
                                    <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />
                                    {formik.values?.status == 4 ? "Draft":"In-Progress"}
                                </span>
                            ) : 
                            (
                                <span className="flex gap-3" style={{ color: "#00B278" }}>
                                    <CheckGreen Filled="#00B278" />
                                    {"Completed"}
                                </span>
                            )}{" "}
                            {queriesFields?.filter((op) => op.resolve == 0)?.length > 0 && (
                                <div className="flex gap-2">
                                    {" "}
                                    <div className="border-l-2 ">
                                        <Typography
                                            variant="body1"
                                            className="ml-2 rounded-3xl text-center align-self-center  text-[0.8rem] w-[1.2rem] h-[1.2rem] text-[white] bg-[#FF0000]"
                                        >
                                            {queriesFields?.filter((op) => op.resolve == 0)?.length}
                                        </Typography>
                                    </div>
                                    <span className="text-[red]">Query Raised</span>
                                </div>
                            )}
                        </p>
                    </div>
                   
                       {isShowPrintButtonCOA && <LoadingButton
                            type="button"
                            size="small"
                            onClick={handleCoaPrint}
                            className="!w-[100px]"
                          >
                            Print
                          </LoadingButton>}
                    
                        </div>
                )}
            </AccordionSummary>
            <AccordionDetails>
                <Divider />
                {isLoadingDetails ? (
                    <SkeletonLoader rowCount={5} height={80} isTable={false} />
                ) : (
                    <div>
                        <CoaQueryHistory
                            queriesFields={queriesFields}
                            preScreenId={currentCycle?.coa_forms_id}
                            type={4}
                        />
                        <form className="!mt-2" onSubmit={formik.handleSubmit}>
                            <Grid container spacing={2} className="mb-3">
                                {formOptions.map((props, key) => {
                                    // Skip rendering if the field has a depend condition that's not met
                                    if (props.depend) {
                                        const dependVal = formik.values[props.depend];
                                        const dependValues = props.dependValue.includes(",")
                                            ? props.dependValue.split(",").map((v) => v.trim())
                                            : [props.dependValue];

                                        if (!dependValues.includes(`${dependVal}`)) {
                                            return null;
                                        }
                                    }

                                    if (props.section) {
                                        return (
                                            <Grid key={key} item xs={12} className="">
                                                {/* Rest of your field rendering code */}
                                                {props.section && (
                                                    <strong className="!pb-3">{props.section}</strong>
                                                )}
                                            </Grid>
                                        );
                                    }
                                    return !props.manualField ? (
                                        <Grid
                                            key={key}
                                            item
                                            xs={props.col && !props.children ? 12 / props.col : 12}
                                        >
                                            {/* Rest of your field rendering code */}
                                            {props.section && (
                                                <strong className="!pb-3">{props.section}</strong>
                                            )}
                                            <FormControl
                                                variant={props.variant ?? "standard"}
                                                fullWidth={props.fullWidth ?? true}
                                                className={`pl-3 pr-3 ${props.section ? "pt-3" : ""} ${props.className ?? ""
                                                    }`}
                                            >
                                                {/* Field labels */}
                                                {props.label && props.children && (
                                                    <FormLabel
                                                        shrink
                                                        required={props.required}
                                                        className="text-[black]"
                                                    >
                                                        {props.label}
                                                    </FormLabel>
                                                )}
                                                {props?.subLable && (
                                                    <Typography
                                                        variant="span"
                                                      className={`z-[1] font-semibold absolute right-5 ${formik.errors[props.name] && formik.touched[props.name]
                                                        ? 'bottom-9'   // move higher when error shows
                                                        : 'bottom-4'   // default position
                                                        } text-[0.7rem]`}
                                                    >
                                                        {props.subLable === "power" ? (
                                                         <p>
                                                            beads/3x10<sup>6</sup>{props?.extraLabel ? props?.extraLabel : ' Cells'}
                                                        </p>
                                                    ):<span className="">{props.subLable}</span>}
                                                    </Typography>
                                                )}
                                                {/* @info calling this for to show unit when -ve value */}
                                                {renderDynamicSubLabel(props, formik)}

                                                {/* Fields */}
                                                {!props.manualValues &&
                                                    !props.isObj &&
                                                    (() => {
                                                        const value = checkForm[props.name];
                                                        const questionInfo = queriesFields?.find(
                                                            (op) =>
                                                                op.fields === props.name ||
                                                                op.fields == props.depend
                                                        );
                                                        return (
                                                            <div className="relative">
                                                                <FormikControl
                                                                    formik={formik}
                                                                    {...props}
                                                                    disabled={
                                                                        questionInfo?.resolve == 0 && hasAuthority(["quality-control-approve-form",'quality-control-lead-approval-listing',"quality-approval-approve-form"], bmr_permissions)
                                                                            ? false
                                                                            : !hasAuthority(["quality-control-approve-form","quality-control-lead-approval-listing","quality-approval-approve-form"], bmr_permissions)
                                                                                ? true
                                                                                : props.disabled
                                                                    }
                                                                    className="mt-2"
                                                                />
                                                                {!props.noQuery &&
                                                                     (questionInfo?.resolve == 0 || (typeof value === "number"
                                                                        ? value === 0 || value !== ""
                                                                        : value !== "")) &&
                                                                    disabledAll &&
                                                                    props.type != "file" ? (
                                                                    <i
                                                                        onClick={(e) =>
                                                                            handleQuestionClick(
                                                                                e,
                                                                                props,
                                                                                questionInfo
                                                                            )
                                                                        }
                                                                        style={
                                                                            questionInfo?.resolve == 0 &&
                                                                                questionInfo.fields == props.name
                                                                                ? { color: "red" }
                                                                                : {}
                                                                        }
                                                                        className={`fas fa-question-circle circle-icon cursor-pointer z-50 absolute right-2 ${!props.label && props.type != "radio"
                                                                            ? "top-[1.2rem]"
                                                                            : props.type == "radio"
                                                                                ? "top-[2rem]"
                                                                                : "top-[0.6rem]"
                                                                            }`}
                                                                        aria-hidden="true"
                                                                    />
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </div>
                                                        );
                                                    })()}
                                            </FormControl>
                                        </Grid>
                                    ) : (
                                        <Grid
                                            key={key}
                                            item
                                            xs={12}
                                            className="flex align-items-baseline"
                                        ></Grid>
                                    );
                                })}
                            </Grid>
                            <CoaFormButtons
                                patientData={patientData}
                                formik={formik}
                                fetchCoaForms={fetchCoaForms}
                                setCoaFormExpanded={setCoaFormExpanded}
                                fetchPatientInfo={fetchPatientInfo}
                                updateTimeLine={updateTimeLine}
                                setIsDraft={setIsDraft}
                            />
                        </form>
                        <COAComment
                            formValues={formik.values}
                            handleMenuClose={handleMenuClose}
                            open={open}
                            anchorEl={anchorEl}
                            selectedField={selectedField}
                            queryData={queryData}
                            checkCOAForm={checkCOAForm}
                            handleManualFormikValidaction={handleManualFormikValidaction}
                            getPrimaryDiagnosis={getPrimaryDiagnosis}
                            initialSteps={initialSteps}
                        />
                    </div>
                )}

                 <COAPrint
                        open={coaPrintModal}
                        onClose={() => {
                          setCoaPrintModal(false);
                        }}
                        printData={checkCOAForm}
                        patientInfo={patientData}
                      />
            </AccordionDetails>
        </Accordion>
    </div >
}
export default COAForm;